<template>
    <button @click="$emit('click')" :class="classes" :disabled='disabled'>
      <slot name="default" />
    </button>
  
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      if (this.disabled) {
        return ['pbc-button-disabled'];
      } else {
        return ['pbc-button'];
      }
    }
  }
  
}
</script>
